import { Actions } from './categorieActions';
import { Actions as UtilisateurActions } from '../utilisateur/courantActions';

/**
 * Etat initial
 */
const initialState = {
    categories: {
        items: [],
        isLoading: false

    }
};

/**
 * Reducer pour les categories
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        case Actions.FETCH_CATEGORIES_REQUEST:
            return {
                ...state,
                categories: { ...state.categories, isLoading: true }
            };
        case Actions.FETCH_CATEGORIES_SUCCESS:
            return {
                ...state,
                categories: { items: [...action.categories], isLoading: false }
            };
        case Actions.FETCH_CATEGORIES_FAILURE:
            return {
                ...state,
                categories: { ...state.categories, isLoading: false, error: action.error }
            }

        case UtilisateurActions.LOGOUT:
            return {
                ...state,
                categories: {
                    items: [],
                    isLoading: false
                }
            };

        default:
    }

    return state;
}

export default reducer;